import { render, staticRenderFns } from "./OnlineConsultationEvent.vue?vue&type=template&id=4c2ec5d6&scoped=true&"
import script from "./OnlineConsultationEvent.vue?vue&type=script&lang=js&"
export * from "./OnlineConsultationEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ec5d6",
  null
  
)

export default component.exports